window.OKJS = window.OKJS || {};
(function (OKJS) {
  var initialized = false;

  OKJS.Global = {
    init: function () {
      // bodymovin elements
      var bmEventsAdded = false;

      OKJS.Global.addOnceEventListener(
        document,
        'OKJS.Initialized',
        function () {
          initialized = true;
        }
      );
    },

    parseJson: function (str) {
      try {
        return JSON.parse(str);
      } catch (e) {
        return undefined;
      }
    },
    safeDecodeURIComponent: function (str) {
      try {
        return decodeURIComponent(str);
      } catch (e) {
        return str;
      }
    },
    readCookieString: function (cookieName) {
      var cookieArray = document.cookie.split('; ');

      for (var i = 0; i < cookieArray.length; i++) {
        var cookieString = cookieArray[i];
        var index = cookieString.indexOf('=');
        if (index > 0) {
          var name = OKJS.Global.safeDecodeURIComponent(
            cookieString.substring(0, index)
          );
          if (name === cookieName) {
            var valuesString = OKJS.Global.safeDecodeURIComponent(
              cookieString.substring(index + 1)
            );
            return valuesString;
          }
        }
      }
    },
    isElementInViewport: function (el) {
      var rect = el.getBoundingClientRect();

      return (
        (rect.height > 0 || rect.width > 0) &&
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },

    // Returns a function, that, when invoked, will only be triggered at most once
    // during a given window of time. Normally, the throttled function will run
    // as much as it can, without ever going more than once per `wait` duration;
    // but if you'd like to disable the execution on the leading edge, pass
    // `{leading: false}`. To disable execution on the trailing edge, ditto.
    throttle: function (func, wait, options) {
      var context, args, result;
      var timeout = null;
      var previous = 0;
      if (!options) options = {};
      var later = function () {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      };
      return function () {
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          previous = now;
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
          timeout = setTimeout(later, remaining);
        }
        return result;
      };
    },
    resetCSSAnimation: function (element, cssClass) {
      element.classList.remove(cssClass);
      void element.offsetWidth;
      element.classList.add(cssClass);
    },
    addOnceEventListener: function (element, type, listener) {
      var triggered = false;
      var wrapper = function () {
        if (triggered) return;
        triggered = true;
        element.removeEventListener(type, wrapper);

        listener.apply(this, arguments);
      };

      element.addEventListener(type, wrapper);
    },
    getComputedTranslateY: function (obj) {
      styleAttr = obj.getAttribute('style');

      translateY = styleAttr.split('(');

      return Number(translateY[1].split('px)')[0]);
    },
    afterInit: function (func) {
      if (initialized) {
        func();
      } else {
        OKJS.Global.addOnceEventListener(document, 'OKJS.Initialized', func);
      }
    },

    injectScriptHtml: function (scriptHtml) {
      var fragment = document.createDocumentFragment();
      var container = document.createElement('div');
      fragment.appendChild(container);

      container.innerHTML = scriptHtml;
      var parsedScript = container.lastChild;

      var script = document.createElement('script');
      if (parsedScript.src) {
        script.src = parsedScript.src;
      } else {
        script.text = parsedScript.text;
      }

      document.head.appendChild(script);
    },
    injectScriptOnce: function (srcPath, callback, scriptType, setDefer) {
      // check if script already have been injected
      var scriptTags = document.getElementsByTagName('script'),
        i = scriptTags.length,
        flag = false,
        setDeferSetting = setDefer ? setDefer : false;

      while (i--) {
        if (scriptTags[i].src === srcPath) {
          flag = true;
          scriptTagRef = scriptTags[i];
          break;
        }
      }

      // wasn't there, add it
      if (!flag) {
        var tag = document.createElement('script');
        tag.src = srcPath;

        if (scriptType !== null && !(scriptType === undefined)) {
          tag.setAttribute('type', scriptType);
        }

        if (setDeferSetting) {
          tag.setAttribute('defer', 'defer');
        }

        document.getElementsByTagName('head')[0].appendChild(tag);

        if (callback !== null) {
          tag.addEventListener('load', function () {
            // Other browsers
            callback();
          });
        }
      } else if (callback !== null) {
        scriptTagRef.addEventListener('load', function () {
          // Other browsers
          callback();
        });
      }
    },
    counterSetup: function (el) {
      function easing(t) {
        return 1 - Math.exp(-t * 7);
      }

      var toValue = Number(el.dataset.countEnd),
        initialValue = Number(el.dataset.countStart);

      // This function will be called repeatedly until the duration has reached
      var step = function (t, elapsed) {
        // easing
        t = easing(t);

        // calculate new value
        var value = (toValue - initialValue) * t + initialValue;

        // limit value ("t" might be higher than "1")
        if (t > 0.999) value = toValue;

        // print value (converts it to an integer)
        el.innerHTML = value | 0;
      };

      // Define the task's specific settings
      var settings = {
        step: step,
        duration: el.dataset.countDuration ? el.dataset.countDuration : 5,
      };

      // create a new "Do-in" task
      var task = new Doin(settings);

      // only activate when it's in viewport
      var throttledStationCounter = OKJS.Global.throttle(
        function () {
          if (OKJS.Global.isElementInViewport(el) && !task.isPlaying) {
            task.start();
            window.removeEventListener(
              'scroll',
              throttledStationCounter,
              'stationCountEventListener'
            );
          }
        },
        500,
        { trailing: true }
      );

      window.addEventListener(
        'scroll',
        throttledStationCounter,
        'stationCountEventListener'
      );

      // run if the element is in viewport at page load
      if (OKJS.Global.isElementInViewport(el) && !task.isPlaying) {
        task.start();
        window.removeEventListener(
          'scroll',
          throttledStationCounter,
          'stationCountEventListener'
        );
      }
    },
    generateQuickGuid: function () {
      return (
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
      );
    },
    loadBmAnimation: function (
      bmElement,
      animationData,
      autoplaySetting,
      loopFromFrameSetting
    ) {
      var bmName = 'bm' + OKJS.Global.generateQuickGuid(),
        bmElementInDom = document.getElementById(bmElement),
        setAutoplay = autoplaySetting ? autoplaySetting : false,
        loopFromFrame = !!loopFromFrameSetting ? loopFromFrameSetting : false;

      var data = {
        container: bmElementInDom,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        animationData: animationData,
        name: bmName,
      };

      var bmAnim = bodymovin.loadAnimation(data);
      var bmDuration = bmAnim.getDuration(true);

      bmElementInDom.dataset.bmname = bmName;
      bmElementInDom.dataset.bmduration = bmDuration;
      bmElementInDom.dataset.bmloopframe = loopFromFrame;

      if (
        setAutoplay ||
        !document
          .getElementsByTagName('html')[0]
          .classList.contains('no-touchevents')
      ) {
        // autoplay when element is in the viewport
        if (!OKJS.Global.init.bmEventsAdded) {
          var throttledAnimation = OKJS.Global.throttle(
            function () {
              OKJS.Global.updateBmAnimation();
            },
            500,
            { trailing: false }
          );

          window.addEventListener(
            'scroll',
            function () {
              requestAnimationFrame(throttledAnimation);
            },
            Modernizr.passiveeventlisteners ? { passive: true } : false
          );
          window.addEventListener(
            'resize',
            function () {
              requestAnimationFrame(throttledAnimation);
            },
            Modernizr.passiveeventlisteners ? { passive: true } : false
          );
          OKJS.Global.init.bmEventsAdded = true;
        }

        OKJS.Global.updateBmAnimation();
      } else {
        //play on hover for no-touch devices
        var throttledMouseOver = OKJS.Global.throttle(
            function () {
              if (loopFromFrame) {
                bmAnim.playSegments(
                  [
                    [0, Number(loopFromFrame) - 1],
                    [Number(loopFromFrame), Number(bmDuration)],
                  ],
                  true
                );
              } else {
                bmAnim.play();
              }
            },
            100,
            { trailing: false }
          ),
          throttledMouseOut = OKJS.Global.throttle(
            function () {
              bodymovin.stop(bmName);
            },
            100,
            { trailing: false }
          );

        document
          .getElementById(bmElement)
          .addEventListener('mouseover', function () {
            requestAnimationFrame(throttledMouseOver);
          });
        document
          .getElementById(bmElement)
          .addEventListener('mouseout', function () {
            requestAnimationFrame(throttledMouseOut);
          });
      }
    },
    updateBmAnimation: function () {
      var bmElements = document.querySelectorAll(
          '.bm-element.js-bm-element-autoplay'
        ),
        registeredAnimations = bodymovin.getRegisteredAnimations();

      for (var i = 0; i < bmElements.length; i++) {
        var bmLoopFrame = bmElements[i].dataset.bmloopframe,
          bmDuration = bmElements[i].dataset.bmduration,
          bmName = bmElements[i].dataset.bmname,
          bmAnimation = registeredAnimations.find(foundAnimation => {
            return foundAnimation.name === bmName;
          });

        if (!bmAnimation) {
          return;
        }

        if (OKJS.Global.isElementInViewport(bmElements[i])) {
          if (bmAnimation.isPaused) {
            if (bmLoopFrame !== 'false') {
              bmAnimation.playSegments(
                [
                  [0, Number(bmLoopFrame) - 1],
                  [Number(bmLoopFrame), Number(bmDuration)],
                ],
                true
              );
            } else {
              bmAnimation.play();
            }
          }
        } else {
          bmAnimation.stop();
        }
      }
    },
  };
})(window.OKJS);
